import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { PlotReportFactElement } from '@/api/rest/resources/types/fact';
import { ChartHeading } from '@/components/Charts/components/ChartHeading';
import { ThreatenedSpeciesChart } from '@/components/Charts/ThreatenedSpecies';
import { RadiusType } from '@/components/MapOverview/components/MapRadiusContextProvider';

import { NoPlotData } from '../NoPlotData';

export const ThreatenedSpeciesGraphTile = ({
  threatenedSpecies,
  radius,
}: {
  threatenedSpecies: PlotReportFactElement[];
  radius?: RadiusType;
}) => {
  const { t } = useTranslation();

  const noChartData = threatenedSpecies.length === 0;

  if (noChartData) {
    return <NoPlotData />;
  }

  return (
    <Stack center data-testid='threatened-species-graph-tile'>
      <Stack spacing={2.5} className='w-full items-center justify-center px-1 py-6 lg:items-start lg:p-8 lg:pl-1'>
        <ChartHeading
          heading={t(
            radius
              ? 'shared.ncaDetail.details.threatenedSpecies.labels.graphHeadlineRadius'
              : 'shared.ncaDetail.details.threatenedSpecies.labels.graphHeadlineNoRadius',
            {
              radius,
            },
          )}
          className='w-full px-6 sm:px-0'
          popover={{
            title: t(
              radius
                ? 'shared.ncaDetail.details.threatenedSpecies.labels.graphHeadlineRadius'
                : 'shared.ncaDetail.details.threatenedSpecies.labels.graphHeadlineNoRadius',
              {
                radius,
              },
            ),
            body: t('shared.ncaDetail.details.threatenedSpecies.labels.graphHeadlineTooltip'),
          }}
        />
        <ThreatenedSpeciesChart data={threatenedSpecies} data-testid='threatened-species-chart' />
      </Stack>
    </Stack>
  );
};
